import { styles, InformationRowVariants } from './InformationRow.css'
import { AppText } from '@otomoro/components/shared/AppText'
import { SanityImage } from '../../SanityImage'
import { SanityAssetDocument } from 'next-sanity'

interface InformationRowProps extends InformationRowVariants {
	row: {
		rowTitle?: string | undefined
		rowContent?: number | undefined
		icons?: SanityAssetDocument[]
	}
}

export const InformationRow: React.FC<InformationRowProps> = ({ row }) => {
	const { rowWrapper, title, description, icons, iconWrapper } = styles()

	return (
		<div className={rowWrapper()}>
			<AppText className={title()} family="condensed" textTransform="uppercase" size="h3">
				{row.rowTitle}
			</AppText>
			{row.icons && (
				<div className={icons()}>
					{row.icons.map((icon, idx: number) => (
						<div key={idx} className={iconWrapper()}>
							<SanityImage image={icon.image} alt={icon.alt} />
						</div>
					))}
				</div>
			)}
			<AppText className={description()} size="small">
				<span className="lg:hidden">Bio-content:</span> {row.rowContent}%
			</AppText>
		</div>
	)
}
